import { serverTimestamp, addDoc, collection, setDoc, doc, getDoc, query, onSnapshot, orderBy, where, limit, startAfter, getDocs } from "firebase/firestore";
import { ellipseSharp } from "ionicons/icons";
import { getCurrentUserUID, db, getCompanyId, sendError } from "./firebase";
import { getSettings } from "./settings";
import { getSmsTemplate } from "./smsTemplates";


var lastItem: any = undefined;
var smsgroup: string | undefined = undefined;

//nalezy wyrejestrować po zamknięciu okna
export function registerSmsSnapshotListener(smsGroup: string, callback: CallableFunction) {
    const q = query(collection(db, 'companies/' + getCompanyId() + '/sms/' + smsGroup + "/smses"), orderBy("created", "desc"), limit(20));
    //console.log("register registerSmsSnapshotListener");
    lastItem = undefined;
    smsgroup = smsGroup;
    return onSnapshot(q, (data: any) => {
        var list: any[] = [];
        data.forEach(function (doc: any) {
            const d = doc.data();
            //dodaje na początku
            list.unshift({ ...d, id: doc.id });
        });
        callback(list);
        if (lastItem === undefined) {
            lastItem = data.docs[data.docs.length - 1];
        }
    }, (err) => {
        console.log("onSmsChange error => " + err.message);
        sendError(err.message);
    })
}

export async function getMoreSmses() {

    var list: any[] = [];
    if (lastItem !== undefined) {
        const q = query(collection(db, 'companies/' + getCompanyId() + '/sms/' + smsgroup + "/smses"), orderBy("created", "desc"), startAfter(lastItem), limit(10));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            const d = doc.data();
            list.unshift({ ...d, id: doc.id });
        });
        if (querySnapshot.docs.length > 0) {
            lastItem = querySnapshot.docs[querySnapshot.docs.length - 1];
        } else {
            lastItem = undefined;
        }
    }
    return list;
}


// export function registerSmsClientSnapshotListener(clientId:string, callback:CallableFunction) {
//     const q = query(collection(db, 'companies/' + getCompanyId() + '/sms'), where("clientId", "==",clientId), orderBy("created", "desc"), limit(20));
//     console.log("register registerSmsClientSnapshotListener");
//     return onSnapshot(q, (data: any) => {
//         var list: any[] = [];
//         data.forEach(function (doc: any) {
//             const d = doc.data();
//             //dodaje na początku
//             list.unshift(d);
//         });
//         callback(list);
//     }, (err) => {
//         console.log("onSmsChange error => " + err.message);
//         sendError(err.message);
//     })
// }

function removePolishCharacters(text: string) {
    const expression = /[ąćęłńóśźż]/gi;

    const replacements = {
        'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ź': 'z', 'ż': 'z',
        'Ą': 'A', 'Ć': 'C', 'Ę': 'E', 'Ł': 'L', 'Ń': 'N', 'Ó': 'O', 'Ś': 'S', 'Ź': 'Z', 'Ż': 'Z'
    };
    //@ts-ignore
    return text.replace(expression, (letter) => replacements[letter]);
}

export async function saveAndSendSms(data: any) {
    //console.log("saveAndSendSms", data);
    try {
        var sender = data.sender;
        if(sender === undefined){
            const settings = await getSettings();
            if(settings !== undefined && settings.allowedSenderNumbers.length >0){
                sender = settings.allowedSenderNumbers[0];
            }
        }
        //console.log(data);
        var saveData = { receiver: data.receiver, sender: sender, eventId:data.event!==undefined?data.event.id:0, text: removePolishCharacters(data.text), direct: "out", created: serverTimestamp(), clientId: data.clientId, userId: getCurrentUserUID() }

        if (saveData.receiver.length === 9) {
            saveData.receiver = "0048" + saveData.receiver;
        }
        if (saveData.receiver.length === 11) {
            saveData.receiver = "00" + saveData.receiver;
        }
        await addDoc(collection(db, 'companies/' + getCompanyId() + '/sms/' + saveData.receiver + "/smses"), saveData).then(function (docRef) {
            try {
                if (data.event !== undefined) {
                    var dataToSave:any= {};
                    var smsList = data.event.smsList;
                    if (smsList === undefined) {
                        smsList = [];
                    }
                    smsList.push({ id: docRef.id, number: saveData.receiver, date: new Date() })
                    dataToSave.smsList = smsList;
                    if(data.templateId !== undefined && data.templateId !== null){
                        let smsTemplate = getSmsTemplate(data.templateId);
                        if(smsTemplate.reminder){
                            dataToSave.reminderSended = true;                            
                        }
                    }
                    setDoc(doc(db, 'companies/' + getCompanyId() + '/events', data.event.id), dataToSave, { merge: true });
                    
                }
            } catch (error) {
                console.error(error);
                sendError("Nie mozna poprawić Wydarzenia!");
            }

        }).catch((error) => {
            console.error(error);
            sendError("Nie mozna dodać SMSa!");
        });
    } catch (e) {
        console.error(e);
        sendError("Nie mozna dodać SMSa!");
    }
}



export async function getSms(number: string, id: string) {
    const docRef = doc(db, 'companies/' + getCompanyId() + '/sms/' + number + "/smses/", id);
    const docSnap = await getDoc(docRef);
    return docSnap.data();
}




